module.exports = __webpack_public_path__ + "img/white-name-logo.d1c7e8ff.png";